const DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * Konkord: whether someone born on this date ("YYYY-MM-DD") has reached the
 * minimum age. Worked out on the person's own device: the date is never sent
 * anywhere, our server only hears yes or no. undefined: not a real past date.
 */
export function oldEnough(
  birthdate: string,
  minimum: number,
  now = Date.now(),
): boolean | undefined {
  const match = DATE.exec(birthdate);
  if (!match) return undefined;
  const [year, month, day] = match.slice(1).map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day ||
    year < 1900 ||
    date.getTime() > now
  ) {
    return undefined;
  }
  const today = new Date(now);
  const birthdayPassed =
    today.getUTCMonth() + 1 > month ||
    (today.getUTCMonth() + 1 === month && today.getUTCDate() >= day);
  return today.getUTCFullYear() - year - (birthdayPassed ? 0 : 1) >= minimum;
}
